import { useActionState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { addAppFile, State } from "../actions";
import FormBody from "../../../../components/form-body";
import Label from "../../../../components/label";
import Input from "../../../../components/input";
import Textarea from "../../../../components/textarea";
import FormError from "../../../../components/form-error";
import { Button } from "../../../../components/button";

export default function AppFileCreateForm(){
    const navigate = useNavigate();
    const initialState: State = {
        message: null,
        success: false,
        errors: {},
        defaultValues: {
            fileName: "",
            description: "",
        },
    };

    const [state, formAction, isPending] = useActionState(
        addAppFile,
        initialState
    );
    useEffect(() => {
        if (state.success) {
            navigate("/admin/app-files");
        }
    }, [state]);

    return (
        <form className="space-y-6 max-w-3xl py-8 text-left" action={formAction}>
            <FormBody>
                <div className="mb-4">
                    <Label htmlFor="fileName">File Name</Label>
                    <Input
                        id="fileName"
                        name="fileName"
                        type="text"
                        placeholder="Enter file name"
                        aria-describedby="fileName-error"
                        defaultValue={state.defaultValues?.fileName ?? ""}
                        required
                    />
                    <FormError id="fileName-error" message={state.errors?.fileName} />
                </div>
                <div className="mb-4">
                    <Label htmlFor="description">Description</Label>
                    <Textarea
                        id="description"
                        name="description"
                        placeholder="Enter description"
                        aria-describedby="description-error"
                        defaultValue={state.defaultValues?.description ?? ""}
                    />
                    <FormError
                        id="description-error"
                        message={state.errors?.description}
                    />
                </div>
                <div className="mb-4">
                    <Label htmlFor="file">File</Label>
                    <Input
                        id="file"
                        name="file"
                        type="file"
                        aria-describedby="file-error"
                        required
                    />
                    <FormError id="file-error" message={state.errors?.file} />
                </div>
            </FormBody>
            <div className="mt-6 flex justify-end gap-4">
                <Link to="/admin/app-files">
                    <Button type="reset" disabled={isPending}>
                        Cancel
                    </Button>
                </Link>
                <Button
                    type="submit"
                    disabled={isPending}
                    loading={isPending}
                    className="min-w-[90px]"
                >
                    Save Changes
                </Button>
            </div>
        </form>
    );
}